import React from 'react';
import reinsightIcon from '../../assets/reinsight-icon.png';
import reinsightMark from '../../assets/reinsight-mark.png';

/**
 * The assistant's visual identity lives here and ONLY here.
 *
 * Two marketing assets (2026-08-20):
 *  - `icon` — the full badge: horse head + speech bubble on the brand-orange
 *    disc (256 px square, disc centred and edge-to-edge). This IS the
 *    collapsed floating button — nothing else is drawn behind it.
 *  - `mark` — the same horse + bubble with NO disc, transparent (128 px).
 *    Used inline next to the name in the panel header and anywhere the
 *    assistant is referenced on a surface that already has a background.
 * Every placement renders this component, so a future asset change is still
 * a one-file swap.
 */
export const ASSISTANT_NAME = 'Reinsight';

export const OFFLINE_HELPER_TEXT = `${ASSISTANT_NAME} needs an internet connection — it will be back when you reconnect`;

export type ReinsightMarkVariant = 'icon' | 'mark';

export interface ReinsightMarkProps {
  /** Rendered square size in px. */
  size?: number;
  /** `icon` = the orange disc badge (the FAB); `mark` = transparent glyph (default). */
  variant?: ReinsightMarkVariant;
  className?: string;
}

export const ReinsightMark: React.FC<ReinsightMarkProps> = ({
  size = 24,
  variant = 'mark',
  className,
}) => (
  <img
    src={variant === 'icon' ? reinsightIcon : reinsightMark}
    alt={ASSISTANT_NAME}
    width={size}
    height={size}
    className={className}
    style={{ display: 'block', width: size, height: size, objectFit: 'contain', flexShrink: 0 }}
    draggable={false}
  />
);

export default ReinsightMark;
